import * as React from "react";
const SvgUnion = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 3H3V16H8V21H21V8H16V3Z", fill: "currentColor" }));
export default SvgUnion;
